
import React from 'react';
import { CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface SuccessViewProps {
  email: string;
  onReset: () => void;
}

const SuccessView: React.FC<SuccessViewProps> = ({ email, onReset }) => {
  return (
    <div className="text-center py-6 space-y-4">
      <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto">
        <CheckCircle className="h-8 w-8 text-green-600" />
      </div>
      <h3 className="font-medium text-lg">Transfer Complete!</h3>
      <p className="text-gray-600">
        The funds have been successfully transferred to {email}.
      </p>
      <Button onClick={onReset} variant="outline" className="mt-4">
        Make Another Transfer
      </Button>
    </div>
  );
};

export default SuccessView;
